import _defineProperty from "/home/runner/work/programming-25/programming-25/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import Loading from '../Loading/Loading.js';
import styles from './styles.js';

// one of the reasons why we use a separate prop for passing ref instead of using forwardref

function MonacoContainer(_ref2) {
  var width = _ref2.width,
    height = _ref2.height,
    isEditorReady = _ref2.isEditorReady,
    loading = _ref2.loading,
    _ref = _ref2._ref,
    className = _ref2.className,
    wrapperClassName = _ref2.wrapperClassName;
  return /*#__PURE__*/React.createElement("section", {
    style: _objectSpread(_objectSpread({}, styles.wrapper), {}, {
      width: width,
      height: height
    }),
    className: wrapperClassName
  }, !isEditorReady && /*#__PURE__*/React.createElement(Loading, {
    content: loading
  }), /*#__PURE__*/React.createElement("div", {
    ref: _ref,
    style: _objectSpread(_objectSpread({}, styles.fullWidth), !isEditorReady && styles.hide),
    className: className
  }));
}
export default MonacoContainer;